import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          平台优势
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          为什么选择榴莲视频观看高清影视
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center group hover:border-primary-200 transition-colors duration-200"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}